module.exports = __webpack_public_path__ + "b11015f3014c1115f4a93fcddc8d8def.png";